import axios from "axios";
import BASE_URL from "../../assets/global/url";

// One Retained Net Income with its cutoffs, creator and net income per cutoff
export const getRetainedNetIncomeById = async (id) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/retained_net_income/getRetainedNetIncomeById`,
      { params: { id } },
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
